export const DOCUMENT_BULK_IMPORT_TRANSFER_KEY =
  "sunny.document_processing.bulk_import_transfer";

export const DOCUMENT_BULK_IMPORT_TRANSFER_EVENT =
  "sunny:document-bulk-import-transfer";

export const readDocumentBulkImportTransfer = () => {
  if (typeof window === "undefined") return null;

  try {
    const stored = window.sessionStorage.getItem(
      DOCUMENT_BULK_IMPORT_TRANSFER_KEY,
    );
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
};

export const clearDocumentBulkImportTransfer = () => {
  if (typeof window === "undefined") return;

  try {
    window.sessionStorage.removeItem(DOCUMENT_BULK_IMPORT_TRANSFER_KEY);
  } catch {
    // Ignore unavailable sessionStorage.
  }
};

export const saveDocumentBulkImportTransfer = (payload) => {
  const nextPayload = {
    ...payload,
    createdAt: new Date().toISOString(),
  };

  if (typeof window === "undefined") return nextPayload;

  try {
    window.sessionStorage.setItem(
      DOCUMENT_BULK_IMPORT_TRANSFER_KEY,
      JSON.stringify(nextPayload),
    );
  } catch {
    // The same-tab event below still lets an already mounted target receive it.
  }

  window.dispatchEvent(
    new CustomEvent(DOCUMENT_BULK_IMPORT_TRANSFER_EVENT, {
      detail: nextPayload,
    }),
  );

  return nextPayload;
};
